import React, { Component } from "react";
import { Row, Table, Tag, Input, Select, Checkbox, Tooltip, Dropdown, Menu, Button, Popconfirm, message } from "antd";
import { PlusOutlined, UploadOutlined, QrcodeOutlined, DownOutlined, DeleteOutlined, EyeOutlined } from "@ant-design/icons";
import { DynamicCardForm, ButtonItem } from "../../../../Components/Items";
import ModalEtiquetasCMMS from "../componentes/ModalEtiquetasCMMS";
import { editarPlan } from "../componentes/accionesPlanes";
import { cmmsPost, estatusPlan, estatusEquipo, formatoFecha } from "../cmmsComun";
import ModalAgregarEquiposContrato from "./ModalAgregarEquiposContrato";
import "../cmms.css";

const { Option } = Select;

// Equipos del contrato y lo que le toca a cada uno en cada vuelta (como las columnas
// "OS 1 TINC / OS 2 TINC" del control de ISSEMYM): incluido o no, folio externo, estatus.
class EquiposContrato extends Component {
    state = { cargando: false, equipos: [], seleccion: [], texto: "", sucursal: null, modalAgregar: false, modalEtiquetas: false };

    componentDidMount() {
        this.consultar();
    }

    componentDidUpdate(prev) {
        if (prev.recarga !== this.props.recarga) this.consultar();
    }

    consultar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "equiposContratoCMMS", { contratoId: this.props.contrato._id });
            if (res.data.success === 2) this.setState((s) => ({ equipos: res.data.equipos, seleccion: s.seleccion.filter((id) => res.data.equipos.some((e) => e._id === id)) }));
            else message.error(res.data.message || "No se pudieron consultar los equipos");
        } finally {
            this.setState({ cargando: false });
        }
    };

    alternar = async (ids, vueltaId, incluir) => {
        const res = await cmmsPost(this.props, "alternarVueltaContratoCMMS", { contratoId: this.props.contrato._id, activosIds: ids, vueltaId, incluir });
        if (res.data.success !== 2) return message.error(res.data.message || "No se pudo cambiar");
        const { creados, borrados, conservados } = res.data;
        if (incluir) message.success(`${creados} servicio(s) programados en la vuelta`);
        else if (conservados) message.warning(`${borrados} quitados · ${conservados} se conservan porque ya tienen servicio o están cerrados`);
        else message.success(`${borrados} quitados de la vuelta`);
        this.consultar();
    };

    quitar = async (ids) => {
        const res = await cmmsPost(this.props, "quitarEquiposContratoCMMS", { contratoId: this.props.contrato._id, activosIds: ids });
        if (res.data.success !== 2) return message.error(res.data.message || "No se pudo quitar");
        message.success(`${ids.length} equipo(s) quitados del contrato`);
        this.setState({ seleccion: [] });
        this.consultar();
        this.props.onCambio?.();
    };

    guardarFolio = async (planId, folio) => {
        if (await editarPlan(this.props, planId, { folioExterno: folio })) message.success("Folio guardado", 1);
    };

    filtrados = () => {
        const t = this.state.texto.trim().toLowerCase();
        return this.state.equipos.filter(
            (e) =>
                (!this.state.sucursal || String(e.direccionId || "") === this.state.sucursal) &&
                (!t || [e.activoTexto, e.numeroInventario, e.idExterno, e.ubicacion, e.area, ...Object.values(e.vueltas).map((p) => p.folioExterno)].some((x) => String(x || "").toLowerCase().includes(t)))
        );
    };

    columnaVuelta = (v) => ({
        title: (
            <div>
                <div>{v.nombre}</div>
                <div style={{ fontSize: 11, color: "#7a8794", fontWeight: 400 }}>
                    {formatoFecha(v.fechaInicio)} – {formatoFecha(v.fechaFin)}
                </div>
            </div>
        ),
        key: String(v._id),
        width: 290,
        render: (_, r) => {
            const p = r.vueltas[String(v._id)];
            const bloqueado = this.props.bloqueado;
            if (!p)
                return (
                    <Tooltip title="No le toca servicio en esta vuelta. Márquelo para incluirlo.">
                        <span className="cmms-celda-vuelta vacia">
                            <Checkbox checked={false} disabled={bloqueado} onChange={() => this.alternar([r._id], v._id, true)} />
                            <span>No incluido</span>
                        </span>
                    </Tooltip>
                );
            const est = estatusPlan(p.estatusVisible);
            const quitable = p.estatus === 1 && !p.servicioId;
            return (
                <span className="cmms-celda-vuelta">
                    <Tooltip title={quitable ? "Quitar de esta vuelta" : "Ya tiene servicio o está cerrado"}>
                        <Checkbox checked disabled={bloqueado || !quitable} onChange={() => this.alternar([r._id], v._id, false)} />
                    </Tooltip>
                    <Tooltip title={[est.label, p.fechaPlaneada && formatoFecha(p.fechaPlaneada), p.empleadoNombre, p.motivoNoRealizado].filter(Boolean).join(" · ")}>
                        <Tag color={est.color} style={{ marginRight: 0 }}>
                            {p.servicioCodigo || (p.fechaPlaneada ? formatoFecha(p.fechaPlaneada) : est.label)}
                        </Tag>
                    </Tooltip>
                    <Input
                        size="small"
                        className="cmms-folio"
                        key={`${p._id}-${p.folioExterno || ""}`}
                        defaultValue={p.folioExterno}
                        placeholder="Folio externo"
                        maxLength={60}
                        disabled={bloqueado}
                        onPressEnter={(e) => e.target.blur()}
                        onBlur={(e) => e.target.value.trim() !== (p.folioExterno || "") && this.guardarFolio(p._id, e.target.value.trim())}
                    />
                    {p.extras ? <Tag>+{p.extras}</Tag> : null}
                </span>
            );
        },
    });

    render() {
        const { contrato, bloqueado } = this.props;
        const vueltas = contrato.vueltas || [];
        const lista = this.filtrados();
        const sucursales = [...new Map(this.state.equipos.filter((e) => e.direccionId).map((e) => [String(e.direccionId), e.sucursalNombre])).entries()];
        const sel = this.state.seleccion;
        const menuVueltas = (incluir) => (
            <Menu onClick={({ key }) => this.alternar(sel, key, incluir)}>
                {vueltas.map((v) => (
                    <Menu.Item key={String(v._id)}>{v.nombre}</Menu.Item>
                ))}
            </Menu>
        );
        const conteoVuelta = (v) => this.state.equipos.filter((e) => e.vueltas[String(v._id)]).length;
        return (
            <Row gutter={14}>
                <DynamicCardForm
                    title={`Equipos del contrato (${this.state.equipos.length})`}
                    xs={24}
                    headerRight={
                        !bloqueado ? (
                            <span style={{ display: "flex", gap: 6 }}>
                                <ButtonItem type="default" size="small" icon={<UploadOutlined />} onClick={() => this.props.history.push("/panel/cmmsImportarProgramaContrato", { contratoId: contrato._id, volverA: { pathname: "/panel/cmmsContrato", state: { id: contrato._id, paso: 2 } } })}>
                                    Importar programa (Excel)
                                </ButtonItem>
                                <ButtonItem type="primary" size="small" icon={<PlusOutlined />} onClick={() => this.setState({ modalAgregar: true })}>
                                    Agregar equipos
                                </ButtonItem>
                            </span>
                        ) : null
                    }
                >
                    <div className="cmms-ayuda">
                        Marque en qué vueltas le toca servicio a cada equipo (un equipo de un servicio al año va en una sola) y capture el folio que el cliente le asignó en cada vuelta, si lo hay. El folio se guarda al salir del campo.
                        {vueltas.length ? ` En el programa: ${vueltas.map((v) => `${v.nombre} ${conteoVuelta(v)}`).join(" · ")}.` : ""}
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center", marginBottom: 8 }}>
                        <Input.Search placeholder="Buscar equipo, serie, inventario, folio..." allowClear style={{ width: 300 }} value={this.state.texto} onChange={(e) => this.setState({ texto: e.target.value })} />
                        <Select allowClear placeholder="Todas las sucursales" style={{ width: 240 }} value={this.state.sucursal || undefined} onChange={(sucursal) => this.setState({ sucursal: sucursal || null })}>
                            {sucursales.map(([id, nombre]) => (
                                <Option key={id} value={id}>
                                    {nombre}
                                </Option>
                            ))}
                        </Select>
                        {sel.length > 0 && (
                            <span className="cmms-barra-seleccion">
                                <b>{sel.length} seleccionados</b>
                                {!bloqueado && (
                                    <>
                                        <Dropdown overlay={menuVueltas(true)} trigger={["click"]}>
                                            <Button size="small">
                                                Incluir en <DownOutlined />
                                            </Button>
                                        </Dropdown>
                                        <Dropdown overlay={menuVueltas(false)} trigger={["click"]}>
                                            <Button size="small">
                                                Quitar de <DownOutlined />
                                            </Button>
                                        </Dropdown>
                                    </>
                                )}
                                <Button size="small" icon={<QrcodeOutlined />} onClick={() => this.setState({ modalEtiquetas: true })}>
                                    Etiquetas
                                </Button>
                                {!bloqueado && (
                                    <Popconfirm
                                        title="¿Quitar estos equipos del contrato? Lo que tengan pendiente sin servicio se borra del programa; lo realizado se conserva."
                                        okText="Quitar"
                                        cancelText="No"
                                        onConfirm={() => this.quitar(sel)}
                                    >
                                        <Button size="small" danger icon={<DeleteOutlined />}>
                                            Quitar del contrato
                                        </Button>
                                    </Popconfirm>
                                )}
                            </span>
                        )}
                    </div>
                    <Table
                        size="small"
                        rowKey="_id"
                        loading={this.state.cargando}
                        dataSource={lista}
                        pagination={{ pageSize: 50, showSizeChanger: true, pageSizeOptions: ["50", "100", "200"], size: "small", showTotal: (t) => `${t} equipo(s)` }}
                        scroll={{ x: 760 + vueltas.length * 290 }}
                        rowSelection={{ selectedRowKeys: sel, onChange: (seleccion) => this.setState({ seleccion }), preserveSelectedRowKeys: true }}
                        locale={{ emptyText: this.state.equipos.length ? "Ningún equipo coincide con el filtro" : "El contrato todavía no tiene equipos. Use 'Agregar equipos' o 'Importar programa'." }}
                        columns={[
                            {
                                title: "Equipo",
                                dataIndex: "activoTexto",
                                width: 300,
                                fixed: "left",
                                render: (v, r) => (
                                    <span>
                                        <Button type="link" size="small" icon={<EyeOutlined />} style={{ padding: 0, height: "auto", marginRight: 4 }} onClick={() => this.props.history.push("/panel/cmmsFichaActivo", { id: r._id })} />
                                        {v}
                                        {r.estado !== 1 ? <Tag style={{ marginLeft: 4 }}>Deshabilitado</Tag> : null}
                                    </span>
                                ),
                            },
                            { title: "Inventario", dataIndex: "numeroInventario", width: 110 },
                            { title: "Sucursal", dataIndex: "sucursalNombre", width: 190 },
                            { title: "Ubicación", width: 150, render: (r) => [r.ubicacion, r.area].filter(Boolean).join(" · ") },
                            { title: "Estatus", dataIndex: "estatusEquipo", width: 120, render: (v) => <Tag color={estatusEquipo(v).color}>{estatusEquipo(v).label}</Tag> },
                            ...vueltas.map(this.columnaVuelta),
                        ]}
                    />
                </DynamicCardForm>
                <ModalAgregarEquiposContrato
                    {...this.props}
                    visible={this.state.modalAgregar}
                    onClose={(agregado) =>
                        this.setState({ modalAgregar: false }, () => {
                            if (agregado) {
                                this.consultar();
                                this.props.onCambio?.();
                            }
                        })
                    }
                />
                <ModalEtiquetasCMMS visible={this.state.modalEtiquetas} ids={sel} onClose={() => this.setState({ modalEtiquetas: false })} />
            </Row>
        );
    }
}

export default EquiposContrato;
